import type { Class } from "@markeroo/shared";

import { Card, DeleteButton, ArchiveButton } from "@/components/cards";
import { StatusBadge } from "@/components/StatusBadge";

interface ClassCardProps {
  classData: Class;
  onNavigate: (classData: Class) => void;
  onArchive: (classData: Class) => void;
  onDeleteForever?: (classData: Class) => void;
  isArchiving?: boolean;
  isDeleting?: boolean;
}

export function ClassCard({
  classData,
  onNavigate,
  onArchive,
  onDeleteForever,
  isArchiving,
  isDeleting,
}: ClassCardProps) {
  const isGcSynced = Boolean(classData.gcCourseId);

  return (
    <Card onClick={() => onNavigate(classData)} data-testid={`class-card-${classData.id}`}>
      <Card.Content>
        <Card.Title>{classData.name}</Card.Title>
        {classData.archived && (
          <div className="mt-1">
            <StatusBadge status="archived" />
          </div>
        )}
      </Card.Content>
      {classData.archived && onDeleteForever && !isGcSynced ? (
        <Card.Actions>
          <ArchiveButton
            onClick={() => onArchive(classData)}
            loading={isArchiving}
            isArchived
          />
          <DeleteButton
            onClick={() => onDeleteForever(classData)}
            loading={isDeleting}
          />
        </Card.Actions>
      ) : !isGcSynced ? (
        <Card.TopRight centered>
          <ArchiveButton
            onClick={() => onArchive(classData)}
            loading={isArchiving}
          />
        </Card.TopRight>
      ) : null}
    </Card>
  );
}
